export default "__VITE_ASSET__BXl6sU83__"